import { commonService } from "./common.service";
import { env } from "../env";

export const lexiqueService = {
  getLexStatutSaisie,
  getLexTypeFeu,
  getLexPeriodeAllumage,
  getLexStatutAdministratif,
  getLexStatutParc,
  getLexEtatParc,
  getLexEquipeDrealById
};

function getLexStatutSaisie() {
  const url = new URL(`${env.apiUrl}/lex/statut-saisies`);

  return commonService.getRessource(url);
}

function getLexTypeFeu() {
  const url = new URL(`${env.apiUrl}/lex/types-feux`);

  return commonService.getRessource(url);
}

function getLexPeriodeAllumage() {
  const url = new URL(`${env.apiUrl}/lex/periodes-allumage`);

  return commonService.getRessource(url);
}

function getLexStatutAdministratif() {
  const url = new URL(`${env.apiUrl}/lex/statut-administratifs`);

  return commonService.getRessource(url);
}

function getLexStatutParc() {
  const url = new URL(`${env.apiUrl}/lex/statut-parcs`);

  return commonService.getRessource(url);
}

function getLexEtatParc() {
  const url = new URL(`${env.apiUrl}/lex/etats-parc`);

  return commonService.getRessource(url);
}

function getLexEquipeDrealById(equipeDrealId) {
  const url = new URL(`${env.apiUrl}/lex/equipes-dreal/${equipeDrealId}`);

  return commonService.getRessource(url);
}
